import axios from "./http";

export const listOrg = data => axios("orgs", { params: data });
export const getOrgAPI = data => axios(`orgs/${data.name}`);
export const createOrgAPI = data => axios.post("orgs", data);
export const updateOrgAPI = data => axios.put(`orgs/${data.name}`, data);
export const removeOrg = data => axios.delete(`orgs/${data.name}`);

export const listOrgTeamsAPI = data => axios(`orgs/${data.name}/teams`);
export const createTeamAPI = (orgname, data) =>
  axios.post(`orgs/${orgname}/teams`, data);

export const listOrgMembersAPI = (orgname, params) =>
  axios(`orgs/${orgname}/members`, { params });
export const addOrgMemberAPI = (orgname, data) =>
  axios.post(`orgs/${orgname}/members`, data);
export const updateOrgMemberAPI = (orgname, username, data) =>
  axios.put(`orgs/${orgname}/members/${username}`, data);
export const deleteOrgMemberAPI = (orgname, username) =>
  axios.delete(`orgs/${orgname}/members/${username}`);
